const unknown = 'Oops! Something went wrong!';
export const messages = {
  error: {
    signUp: {
      emailAlreadyExists: 'An account with the same email already exists.',
      postalCodeRequired: 'Work zip code is required',
      emailInvalid: 'Email address invalid. Please try again.',
    },
    login: {
      incorrectCredentials: 'The email and password combination are invalid. Please try again.',
      userDisabled: 'This user is temporarily disabled',
      stateUnmatched:
        'Log in failed. This is typically because it took too long before authenticate. Please try again.',
      popupBlocked: 'Pop-up blocked. Allow pop-up, and try again.',
      accountConflicts: 'An account with the same email already exists. Sign in with the account.',
      tooManyAttemptsTryLater: 'Too many failed login attempts. Please wait and try again.',
      unknown,
    },
    resetPassword: {
      invalidOobCode: 'The request was invalid. Please try the password reset procedure again.',
      unknown,
    },
    changeEmail: {
      emailAlreadyExists: 'An account with the new email already exists.',
      emailInvalid: 'Email address invalid. Please try again.',
      unknown,
    },
    recoverEmail: {
      invalidOobCode: 'The request is invalid.',
      expiredOobCode: 'This URL is expired.',
      unknown,
    },
    confirmEmailVerification: {
      invalidOobCode: 'The request is invalid.',
      expiredOobCode: 'This URL is expired.',
    },
    acquisition: {
      emailAlreadyExists: 'Email already exists. Please log in.',
      emailInvalid: 'Email address invalid. Please try again.',
      acquisitionParamsNotFound: 'Something went wrong!, please try signing up',
      unknown,
    },
  },
};
